/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Schema$RewardUnit } from '@protocol/component'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import { RewardCompleteWrap } from './index.style'

// img
import diaImg from '@assets/images/icon/money_icon/dia-01.png'
import moneyImg from '@assets/images/icon/money_icon/money-02-nobg.png'

interface RewardCompletePopupProps {
  popupType: REWARD_COMPLETE_POPUP_TYPE
  item: Schema$RewardUnit
}

export enum REWARD_COMPLETE_POPUP_TYPE {
  ATTENDANCE,
  LIVE_BET_EVENT,
}

const REWARD_COMPLETE_POPUP_TEXT = {
  [REWARD_COMPLETE_POPUP_TYPE.ATTENDANCE]: '출석 보상',
  [REWARD_COMPLETE_POPUP_TYPE.LIVE_BET_EVENT]: '라이브 인증 보상',
}

const REWARD_COMPLETE_POPUP_MONEY_IMAGE = {
  [PROPERTY_ID.MONEY]: moneyImg,
  [PROPERTY_ID.DIA]: diaImg,
}

export const RewardCompletePopup: React.FC<RewardCompletePopupProps> = observer((props: RewardCompletePopupProps) => {
  const { popupType, item } = props

  let rewardImage

  switch (popupType) {
    case REWARD_COMPLETE_POPUP_TYPE.ATTENDANCE:
      rewardImage = REWARD_COMPLETE_POPUP_MONEY_IMAGE?.[item.propertyId]
        ?? REWARD_COMPLETE_POPUP_MONEY_IMAGE[PROPERTY_ID.DIA]
      break
    case REWARD_COMPLETE_POPUP_TYPE.LIVE_BET_EVENT:
      rewardImage = REWARD_COMPLETE_POPUP_MONEY_IMAGE?.[item.propertyId]
        ?? REWARD_COMPLETE_POPUP_MONEY_IMAGE[PROPERTY_ID.MONEY]
      break
  }

  return (
    <RewardCompleteWrap>
      <img src={`${rewardImage}`} alt="보상 이미지" className="reward-img"/>
      {item.volume > 0 && <span className="reward-value">{item.volume.toLocaleString()} {item.name} 획득!</span>}
      {item.quantity > 0 && <span className="reward-value">{item.quantity}</span>}
      {item.period > 0 && <span className="reward-value">{item.period}</span>}
      <p className="reward-complete-txt">
        {REWARD_COMPLETE_POPUP_TEXT[popupType]}이 메세지함으로 지급되었습니다.
      </p>
    </RewardCompleteWrap>
  )
})
